/**
 * descript 车机api调用方法
 * create_time 2022年1月24日18:42:59
 * create_user 10600
 */

// 车机停止语音播报
const stopTTS = () => {
    if (window.android.stopTTS) {
        window.android.stopTTS();
        return;
    }
};
// 车机语音播报
const speechText = (str) => {
    if (window.android.speechStr) {
        window.android.speechStr(str);
        return;
    }
};

// 车机视频是否可以播放
const isCanPlayVideo = () => {
    if (window.android.isCanPlayVideo) {
        return window.android.isCanPlayVideo();
    }
};

// 获取OTA版本号
const getOTAVersion = () => {
    if (window.android.getOTAVersion) {
        return window.android.getOTAVersion();
    }
};

// 获取车辆VIN码 消息中心、功能地图都提供
const getCarVin = () => {
    if (window.android?.getCarVin) {
        return window.android.getCarVin();
    }
};
// 获取车型 // 功能地图新加、消息中心复用
const getCarType = () => {
    if (window.android?.getCarType) {
        return window.android.getCarType();
    }
};

// 获取年款 // 消息中心新加 C11-26款不一致
const getModelYear = () => {
    if (window.android.getModelYear) {
        return window.android.getModelYear();
    }
};
// 获取车型架构 消息中心区分尺寸 E3.5+ 返回true, 其余false
const getPlatformFramework = () => {
    if (window.android?.getPlatformFramework) {
        return window.android.getPlatformFramework();
    }
};

// 关闭webview
const closeMsg = () => {
    if (window.android.closeMsg) {
        return window.android.closeMsg();
    }
};

const openDetailMsg = () => {
    if (window.android.openDetailMsg) {
        return window.android.openDetailMsg();
    }
};
// 消息已读操作
const doReadMsg = () => {
    if (window.android.doReadMsg) {
        return window.android.doReadMsg();
    }
};
// 打开第几个h5
/**
 *
 * @param  {...any} rest
 * 当有一个参数时，是打开第几个h5,
 * 当有两个参数时，第一个参数是url地址String url，第二个参数是位置int[] [width, height, top, left] - 去掉了
 * @returns
 */
const openMsg = (index) => {
    if (window.android.openMsg) {
        window.android.openMsg(index);
    }
};

// 获取消息时间函数 例：20分钟前
const getMsgTimeStr = () => {
    if (window.android.getMsgTimeStamp) {
        return window.android.getMsgTimeStamp();
    }
};

// 获取mqtt发给车端的所有信息
/**
 *
 * @returns {"biztype":"MessagePush",
 * "reqtype":"req",
 * "timestamp":1646735160151,
 * "msgid":42,
 * "module":"C11",
 * "data":{
 *  "type":0,
 *  "tag":2,
 *  "name":"微信测试1",
 *  "desc":"微信测试1描述",
 *  "appName":"null",
 *  "startTime":1646734312000,
 *  "endTime":1646820712000,
 *  "busType":0,
 *  "busValue":"null",
 *  "includeVideo":1,
 *  "showType":0,
 *  "keepTime":10,
 *  "level":2,
 *  "abbrUrl":"",
 *  "abbrParams":"[]",
 *  "bodyParams":"[]",
 *  "isReaded":false,
 *  "vehicleShowJson":"[{\"url\":\"https:\\\/\\\/devappweb.leapmotor.com\\\/thumb-wechat?msgId=43\",\"showSize\":\"[834, 267, 120, 650]\"}, {\"url\":\"https:\\\/\\\/devappweb.leapmotor.com\\\/content-wechat?msgId=43\",\"showSize\":\"[1640, 880, 79, 280]\"}]"}}
 */
const getNoticeDetail = () => {
    if (window.android.getNoticeDetail) {
        return JSON.parse(window.android.getNoticeDetail());
    }
};

/**
 * 打开某个车机应用，应用编号
 * @param {*} type number
 * @returns
 */
const doAction = (type) => {
    if (window.android.doAction) {
        return window.android.doAction(type);
    }
};
/**
 * 打开某个车机功能模块，模块类型
 * @param {*} module string
 * autoparking      自动泊车
 * autodriving      辅助驾驶
 * drivingmode      驾驶模式
 * autohold         autohold
 * reservecharging  预约充电
 * face             人脸识别
 * voicetoplay      语音控制多媒体
 * voicetoair       语音控制空调
 * @returns
 */
const doTryFunction = (module) => {
    if (window.android.doTryFunction) {
        return window.android.doTryFunction(module);
    }
};

// 设置不再提醒时关闭功能模块
const closeRemind = (module) => {
    if (window.android.closeRemind) {
        return window.android.closeRemind(module);
    }
};
// 功能模块是否允许通知
const allowRemind = (module, boolean) => {
    if (window.android.allowRemind) {
        return window.android.allowRemind(module, boolean);
    }
};
// 功能地图本地播放视频
const playVideo = (url) => {
    if (window.android.playVideo) {
        return window.android.playVideo(url);
    }
};

/**
 * 功能地图二期车机弹窗消息 msg: String
 */
const showToast = (msg) => {
    if (window.android.showToast) {
        return window.android.showToast(msg);
    }
};
/**
 * 功能地图二期解锁壁纸 id: int
 */
const unlockWallpaper = (id) => {
    if (window.android.unlockWallpaper) {
        return window.android.unlockWallpaper(id);
    }
};
/**
 * 功能地图二期打开壁纸应用 id: int
 */
const jumpToWallpaper = (id) => {
    if (window.android.jumpToWallpaper) {
        return window.android.jumpToWallpaper(id);
    }
};

/**
 * 功能地图三期返回交互,结束当前页面，返回上一页
 */
const finish = () => {
    if (window.android.finish) {
        return window.android.finish();
    }
};
/**
 * 功能地图三期打开周报弹窗
 */
const openReport = () => {
    if (window.android.openReport) {
        return window.android.openReport();
    }
};
/**
 * 功能地图三期关闭引导
 */
const guideClose = () => {
    if (window.android.guideClose) {
        return window.android.guideClose();
    }
};
/**
 * 功能地图三期获取屏幕尺寸
 * 返回值：{width: number, height: number} 例如B10: "2560,1440"
 */
const getScreenSize = () => {
    if (window.android?.getScreenSize) {
        return window.android?.getScreenSize();
    }
};

/**
 * Array[string] ['确认', '取消']
 * 用来在车机上 做到可见即可说
 */

const setMvmKeywords = (keywords) => {
    if (window.android.setMvmKeywords) {
        return window.android.setMvmKeywords(keywords);
    }
};

export {
    stopTTS,
    speechText,
    isCanPlayVideo,
    getOTAVersion,
    getCarVin,
    closeMsg,
    openDetailMsg,
    openMsg,
    doReadMsg,
    getNoticeDetail,
    doAction,
    setMvmKeywords,
    doTryFunction,
    closeRemind,
    allowRemind,
    playVideo,
    showToast,
    unlockWallpaper,
    jumpToWallpaper,
    getCarType,
    getModelYear,
    getMsgTimeStr,
    finish,
    openReport,
    guideClose,
    getScreenSize,
    getPlatformFramework,
};
/**
 * {
    type: 0,
    data: {
        "address": "滨江区江虹路",
        "addresskey": "10214",
        "latitude": "30.183258057",
        "longitude": "120.204719543",
        "addressname": "华为技术有限公司杭州研究所(滨江区)"
    }
}
 */
